import { OpsReferral } from '../../../interfaces/referral';

/** Where the Referrals section lives. */
export const REFERRALS_HUB_PATH = '/referrals/hub';

/** A referral's page in the section: the referral beside its source document. */
export const referralOpenPath = (referral: Pick<OpsReferral, 'id'>): string =>
  `${REFERRALS_HUB_PATH}/${referral.id}`;

/**
 * The referral page the list last opened, and the list's query when it did.
 *
 * In memory, in this module, on purpose. Router state does not work: react-admin runs on hash
 * history, whose `push(path, state)` drops the state, so the detail page never saw where it
 * came from. And not `sessionStorage`: the query can hold a patient-name search (HIPAA, see
 * CLAUDE.md). A reload forgets it, which only means Back opens the unfiltered list.
 */
let openedFromList: { path: string; listSearch: string } | null = null;

/** Called by the list as it opens a referral's page. */
export const rememberOpenedFromList = (path: string, listSearch: string): void => {
  openedFromList = { path, listSearch };
};

/** Called by the list when it shows, so a later visit to a referral starts unmarked. */
export const forgetOpenedFromList = (): void => {
  openedFromList = null;
};

/** The list's query if `path` is the referral page the list just opened, else `null`. */
export const listSearchFor = (path: string): string | null =>
  openedFromList?.path === path ? openedFromList.listSearch : null;
